import * as actionTypes from './actionTypes'
import {
    fetchWithCookieRefresh, handleResponseError, formatCollectMessageDataToLocal,
} from '../../../utils'

import { message } from 'antd'


export const filterCategoryListAction = (data) => ({
    type: actionTypes.DATETIME_CATEGORY_LIST_ACTION,
    data: data,
})

export const contentCategoryListAction = (data) => ({
    type: actionTypes.CONTENT_CATEGORY_LIST_ACTION,
    data: data,
})

export const getCollectData = () => {
    return (dispatch, getState) => {
        // return fetchWithCookieRefresh(`/api/collection_list.json`, {
        fetchWithCookieRefresh('/api/collection/list', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                console.log("/api/collection/list data = ", data);
                let conversation_list = []
                let message_list = []
                data.data.forEach(element => {
                    if (element.resource_type === 'conversation') {
                        element['is_edit_name'] = false
                        element['conversation_name_edit'] = ''
                        conversation_list.push(element)
                    } else {
                        message_list.push(element)
                    }
                });
                dispatch(collectionConversationListAction(conversation_list))
                let temp_mall_components_list = getState().get("collect").get("mall_components_list").toJS()
                let d = formatCollectMessageDataToLocal({ data: message_list, mall_components_list: temp_mall_components_list })
                dispatch(collectionMessageListAction(d))
            })
            .catch(error => { })
    }
}

export const collectionConversationListAction = (data) => ({
    type: actionTypes.COLLECTION_CONVERSATION_LIST,
    data: data,
})

export const collectionMessageListAction = (data) => ({
    type: actionTypes.COLLECTION_MESSAGE_LIST,
    data: data,
})

export const postCollectionCreate = (is_collection, resource_type, resource_id) => {
    return (dispatch, getState) => {
        fetchWithCookieRefresh('/api/collection/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource_id: resource_id,
                resource_type: resource_type,
                is_delete: is_collection,
            }),
        })
            .then(data => {
                dispatch(getCollectData())
            })
            .catch(error => {
                handleResponseError(message, error)
            })
    }
}

export const conversationNameBlurAction = (conversation_id) => {
    return (dispatch, getState) => {
        let collection_conversation_list = getState().get("collect").get("collection_conversation_list").toJS()
        let obj = collection_conversation_list.find(item => item.conversation_id === conversation_id)
        if (obj.conversation_name_edit === obj.conversation_name) {
            // 前后名字一样，没有改变
            obj.is_edit_name = false
            obj.conversation_name_edit = ''
            dispatch(collectionConversationListAction(collection_conversation_list))
        } else {
            fetchWithCookieRefresh('/api/history/conversation', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "conversation_id": obj.conversation_id,
                    "conversation_name": obj.conversation_name_edit
                }),
            })
                .then(data => {
                    console.log("/api/history/conversation success");
                    obj.is_edit_name = false
                    obj.conversation_name = obj.conversation_name_edit
                    obj.conversation_name_edit = ''
                    dispatch(collectionConversationListAction(collection_conversation_list))
                })
                .catch(error => {
                    handleResponseError(message, error)
                    obj.is_edit_name = false
                    obj.conversation_name_edit = ''
                    dispatch(collectionConversationListAction(collection_conversation_list))
                })
        }
    }
}

export const conversationRenameAction = (conversation_id) => {
    return (dispatch, getState) => {
        let collection_conversation_list = getState().get("collect").get("collection_conversation_list").toJS()
        let obj = collection_conversation_list.find(item => item.conversation_id === conversation_id)
        if (!obj.is_edit_name) {
            obj.is_edit_name = true
            obj.conversation_name_edit = obj.conversation_name
            dispatch(collectionConversationListAction(collection_conversation_list))
        }
    }
}

export const deleteConversationAction = (conversation_id) => {
    return (dispatch, getState) => {
        fetchWithCookieRefresh('/api/history/conversation', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                conversation_id: conversation_id,
            })
        })
            .then(data => {
                dispatch(getCollectData())
            })
            .catch(error => {
                handleResponseError(message, error)
            })
    }
}

export const getStoreComponentsList = () => {
    return (dispatch, getState) => {
        // fetchWithCookieRefresh('/api/store_components_list.json', {
        fetchWithCookieRefresh('/api/store/components/list', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                console.log("/api/store/components/list data = ", data);
                dispatch(setMallComponentsList(data?.data))
                dispatch(getCollectData())
            })
            .catch(error => { })
    }
}

export const setMallComponentsList = (data) => ({
    type: actionTypes.SET_MALL_COMPONENTS_LIST,
    data: data,
})

export const getMessagePictureClick = (doc_id) => {
    let args = `?doc_id=${doc_id}`

    return (dispatch, getState) => {
        fetchWithCookieRefresh('/api/history/picture/click' + args, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(data => {
            console.log("/api/history/picture/click data = ", data);
        })
        .catch(error => {})
    }
}
